import { Component } from "react";
import styles from "./error-boundary.module.scss";
import PrimaryButton from "../../common/buttons/primary-button/PrimaryButton";
import { BASE_ROUTE, LOGIN_ROUTE } from "@/routing/app-routes";
import i18n from "@/utils/i18n";
import CenteredContent from "../../common/layouts/centered-content/centered-content";
import SecondaryButton from "@/components/common/buttons/secondary-button/SecondaryButton";

class ErrorBoundary extends Component {
  state = { hasError: false, error: null, errorInfo: null };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can log the error to an error reporting service here
    console.error("Error caught by boundary:", error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <CenteredContent
          title={i18n.t("oopsAnErrorOccurred")}
          subTitle={i18n.t("ifThisErrorPersists")}
        >
          <div id="error-boundary" className={`${styles.errorBoundary}`}>
            {process.env.NODE_ENV !== "production" && (
              <>
                <div className={`${styles.errorMessage} mb-4`}>
                  <span>{this.state.error?.message || "Unknown error"}</span>
                </div>
                <details className="mb-8">
                  <div
                    className={`${styles.errorDetails} ${styles.emphasize} mb-2`}
                  >
                    {this.state.error?.toString()}
                  </div>
                  <div className={styles.errorDetails}>
                    {this.state.errorInfo?.componentStack}
                  </div>
                </details>
              </>
            )}
            <div className="flex full center col-gap-4">
              <div className="one-quarter">
                <SecondaryButton
                  text={i18n.t("login")}
                  onClick={() => (window.location.href = LOGIN_ROUTE)}
                />
              </div>
              <div className="one-quarter">
                <PrimaryButton
                  text={i18n.t("home")}
                  onClick={() => (window.location.href = BASE_ROUTE)}
                />
              </div>
            </div>
          </div>
        </CenteredContent>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
